import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class FullScreenSpinnerService {

  public message = 'Now Loading...';

  constructor(private sppinerService: NgxSpinnerService) { }

  public show(text: string = 'Now Loading...') {
    this.message = text;
    this.sppinerService.show();
  }

  public hide() { this.sppinerService.hide(); }
}
